export default {
    occupation:         { method: 'get',    url: 'ambiences/occupation' },
    occupationIdeal:    { method: 'get',    url: 'ambiences/occupation_ideal' },
    balance:            { method: 'get',    url: 'ambiences/balance' },
}